import { createFileRoute, Link } from "@tanstack/react-router";
import { Typography, Table, Tag, Flex, Button, theme } from "antd";
import { useQ_PageGodMode_Flows } from "@/hooks/GodMode/useQ_PageGodMode_Flows";
import { const_FlowStatusOptions } from "@/hooks/GodMode/const_FlowStatusOptions";
import type { PageGodMode_Flows_QueryData } from "@/hooks/GodMode/useQ_PageGodMode_Flows";
import type { Supabase_Enums } from "@gotoIHUB/db-types";

export const Route = createFileRoute("/_protected/_god-mode/god-mode/flows")({
  component: Page_GodMode_Flows,
});

function Page_GodMode_Flows() {
  const { token } = theme.useToken();
  const qFlows = useQ_PageGodMode_Flows();

  const columns = [
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
      render: (slug: string) => <Typography.Text code>{slug}</Typography.Text>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Carrier",
      dataIndex: "carrier",
      key: "carrier",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: Supabase_Enums<"flow_status_enum">) => {
        const meta = const_FlowStatusOptions.map[status];
        return meta ? <Tag color={meta.color}>{meta.label}</Tag> : null;
      },
    },
    {
      title: "Orgs",
      key: "orgs",
      render: (_: unknown, record: PageGodMode_Flows_QueryData[number]) =>
        (record.admin__rel__flows__organizations as { count: number }[])?.[0]?.count ?? 0,
    },
  ];

  return (
    <div>
      <Flex gap={token.marginMD} style={{ marginBottom: token.marginLG }}>
        <Link to="/god-mode">
          <Button type={undefined}>Organizations</Button>
        </Link>
        <Button type="primary">Flows</Button>
      </Flex>

      <Flex justify="space-between" align="center" style={{ marginBottom: token.marginLG }}>
        <Typography.Title level={2} style={{ margin: 0 }}>Flows</Typography.Title>
        <Typography.Text type="secondary">Flows are defined in code and registered via migrations</Typography.Text>
      </Flex>

      <Table
        dataSource={qFlows.flows}
        columns={columns}
        rowKey="id"
        loading={qFlows.query.isLoading}
        pagination={false}
      />
    </div>
  );
}
